<template>
  <div class="text-center card">
    <div>
      <h1>{{ $t("register.success.title") }}</h1>

      <v-img
        :src="require('@/assets/images/auth/check-circle.png')"
        max-width="114"
        class="mx-auto my-10"
        alt="Image"
        contain
      />
    </div>
    <v-spacer />

    <div class="mx-auto" style="max-width: 550px">
      <p>
        {{ $t("register.success.text1") }}
        <br />
        {{ $t("register.success.text2") }}
      </p>
      <v-divider class="my-5" />

      <p>
        {{ $t("login.notVerified.text2") }}
      </p>

      <div class="text-center" v-if="showButton">
        <v-btn
          color="primary"
          @click="sendVerificationLink"
          :loading="$loading('auth/sendVerificationLink')"
        >
          {{ $t("login.notVerified.button") }}
        </v-btn>
      </div>

      <small class="d-block text-center mt-3">
        <router-link :to="{ name: 'auth.login' }">
          {{ $t("login.returnToLogin") }}
        </router-link>
      </small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    showButton: true,
  }),

  methods: {
    sendVerificationLink() {
      this.$store
        .dispatch("auth/sendVerificationLink", this.email)
        .then((data) => {
          this.$toast.success(data.message);
          this.showButton = false;
        })
        .catch(() => {
          this.$toast.error(this.$t("common.error"));
        });
    },
  },
};
</script>

<style></style>
